import { useHttpClient } from '@/libs/http'
import { useStaffService } from '@/modules/channel'

import IAuthService from './auth.interface'
import AuthService from './auth.service'

const useAuthService = (): IAuthService => {
  const { getInstanceWithoutToken } = useHttpClient()
  const staffService = useStaffService()
  return new AuthService(getInstanceWithoutToken(), staffService)
}

export default useAuthService
